import React from "react";

const socialHandles = [
  {
    icon: "/icons/LinkedIn.svg",
    alt: "LinkedIn",
    href: "https://www.linkedin.com/in/gauravdix",
  },
  {
    icon: "/icons/Calendly.svg",
    alt: "Calendly",
    href: "https://calendly.com/contact-datapixl",
  },
];

const OurFounderCard = ({
  title,
  position,
  description,
  imageUrl,
  left = true,
}) => {
  return (
    <div
      className={`flex flex-col-reverse ${
        left ? "md:flex-row" : "md:flex-row-reverse"
      } space-y-10 md:space-y-0 md:space-x-20 justify-center items-center`}
    >
      <div className="flex flex-col items-start">
        <p className="mt-4 font-bold text-lg md:text-[24px] leading-[140%] tracking-[0%] font-theBrittanySans uppercase">
          {title}
        </p>
        <p className="font-theBrittanySans font-normal text-[12px] leading-[140%] tracking-[0%] md:mb-4">
          {position}
        </p>
        <p className="md:text-xl mt-4 leading-[145%] tracking-[0%] mb-4 md:mb-12 ">
          {description}
        </p>
        <div className="flex flex-row items-center justify-center space-x-7 md:space-x-8">
          {socialHandles.map((social) => (
            <a href={social.href} target="_blank" rel="noopener noreferrer">
              <img
                className="w-10 h-10 cursor-pointer"
                src={social.icon}
                alt={social.alt}
              />
            </a>
          ))}
        </div>
      </div>

      {imageUrl && (
        <img
          src={imageUrl}
          alt="AI Strategy"
          className="aspect-square md:w-[32%] object-cover object-center grayscale rounded-lg"
        />
      )}
    </div>
  );
};

export default OurFounderCard;
